import { Divider, IconButton, Typography } from '@mui/material';
import { DataGridFloatingActionToolbar } from './DataGridFloatingActionToolbar';
import { CloseRounded } from '@mui/icons-material';
import { useMyAssortmentTFunction } from '@retail/my-assortment/i18n';
import { ReactNode } from 'react';

interface Props {
  totalItems: number;
  itemsChecked: number;
  actions: ReactNode;
  resetChecked: () => void;
}

export function DataGridFloatingActionToolbarBase({
  totalItems,
  itemsChecked,
  actions,
  resetChecked,
}: Props) {
  const t = useMyAssortmentTFunction();
  return (
    <DataGridFloatingActionToolbar>
      <IconButton
        sx={{ p: 0, color: 'inherit', ':hover': { color: 'common.black' } }}
        onClick={resetChecked}
      >
        <CloseRounded fontSize="small" />
      </IconButton>

      <Divider orientation="vertical" sx={{ height: 'auto' }} />

      <Typography variant="subtitle2" whiteSpace="nowrap">
        {t('myAssortment.nrOfItemsSelected', { items: itemsChecked, totalItems })}
      </Typography>

      {actions}
    </DataGridFloatingActionToolbar>
  );
}
